import { SETTINGS_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const SettingsService = {
  getAll: (params: any) => requests.get(`${SETTINGS_URL}`, params),
  create: (params: any) => requests.post(`${SETTINGS_URL}`, params),
  getSingle: () => requests.get(`${SETTINGS_URL}`),
  update: (params: any) => requests.put(`${SETTINGS_URL}`, params),
  delete: (id: number) => requests.delete(`${SETTINGS_URL}/${id}`),
};